import { NgIf } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, OnChanges } from '@angular/core';

@Component({
  selector: 'app-svg',
  templateUrl: './svg.component.html',
  styleUrls: ['./svg.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [NgIf],
})
export class SvgComponent implements OnChanges {
  @Input({ required: true }) src: string;
  // eslint-disable-next-line @angular-eslint/no-input-rename
  @Input('width') _width?: number;
  // eslint-disable-next-line @angular-eslint/no-input-rename
  @Input('height') _height?: number;
  @Input() alt?: string;
  width: number;
  height: number;
  href: string;

  ngOnChanges() {
    this.href = this.src + '?v1#main';
    if (this._width) this.width = this._width;
    else this.width = this.getSize();

    if (this._height) this.height = this._height;
    else this.height = this.width;
  }

  private getSize() {
    if (this.src.includes('/12/')) return 12;
    if (this.src.includes('/16/')) return 16;
    if (this.src.includes('/18/')) return 18;
    if (this.src.includes('/24/')) return 24;
    if (this.src.includes('/64/')) return 64;
    if (this.src.includes('/96/')) return 96;
    if (this.src.includes('/144/')) return 144;
    return 32;
  }
}
